import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const AddExchangeDirectCost = createAsyncThunk(
  "dropdowns/GetReport_",
  async (Parameter, { rejectWithValue }) => {
    console.log("sdsdssaccascdsdsdsd");
    
    try {
      
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/PR_Reports/GetRportsByAppGUID",Parameter
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const DeleteExchangeDirectCost = createAsyncThunk(
    "dropdowns/DeleteExchangeDirectCost",
    async (Parameter, { rejectWithValue }) => {
      console.log("sdsdssaccascdsdsdsd");
      
      try {
        
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/ExchangDirectCost/DeletePR_ExchangeInformationItemImplementationStages",Parameter
        );
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "dataaaa");
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );

  export const GetExchangeInformationItemImplementationStagesByID = createAsyncThunk(
    "dropdowns/GetExchangeInformationItemImplementationStagesByID",
    async (Parameter, { rejectWithValue }) => {
      console.log("sdsdssaccascdsdsdsd");
      
      try {
        
        await initializeApiClient();
        const apiClient = await getApiClient();
        const response = await apiClient.post(
          "api/ExchangDirectCost/GetpR_ExchangeInformationItemImplementationStagesByID",Parameter
        );
  
        // Extract data from the response object
        const data = response.data.result; // Assuming response has a "data" field
        //console.log(data, "dataaaa");
  
        return data; // Return the extracted data
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );



const ExchangeDirectCostReducers = createSlice({
  name: "TypeOfJobOpportunityDropDown",
  initialState: {
    ReportByApp: [],
    loadingReportByApp: false,
    errorReportByApp: null,
    ////////////////////////////////////
    DeleteExchange: [],
    loadingDeleteExchange: false,
    errorDeleteExchange: null,
    ////////////////////////////////////
    GetExchangeInformation: [],
    loadingGetExchangeInformation: false,
    errorGetExchangeInformation: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(AddExchangeDirectCost.pending, (state, action) => {
        state.loadingReportByApp = true;
        state.ReportByApp = action.payload;
        state.errorReportByApp = null;
      })
      .addCase(AddExchangeDirectCost.fulfilled, (state, action) => {
        state.loadingReportByApp = false;
        state.ReportByApp = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddExchangeDirectCost.rejected, (state, action) => {
        state.loadingReportByApp = false;
        state.errorReportByApp = action.payload;
      });
      ////////////////////////////////////////////////////
      builder
      .addCase(DeleteExchangeDirectCost.pending, (state, action) => {
        state.loadingDeleteExchange = true;
        state.DeleteExchange = action.payload;
        state.errorDeleteExchange = null;
      })
      .addCase(DeleteExchangeDirectCost.fulfilled, (state, action) => {
        state.loadingDeleteExchange = false;
        state.DeleteExchange = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteExchangeDirectCost.rejected, (state, action) => {
        state.loadingDeleteExchange = false;
        state.errorDeleteExchange = action.payload;
      });
      ////////////////////////////////////////////////////
      builder
      .addCase(GetExchangeInformationItemImplementationStagesByID.pending, (state, action) => {
        state.loadingGetExchangeInformation = true;
        state.GetExchangeInformation = action.payload;
        state.errorGetExchangeInformation = null;
      })
      .addCase(GetExchangeInformationItemImplementationStagesByID.fulfilled, (state, action) => {
        state.loadingGetExchangeInformation = false;
        state.GetExchangeInformation = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetExchangeInformationItemImplementationStagesByID.rejected, (state, action) => {
        state.loadingGetExchangeInformation = false;
        state.errorGetExchangeInformation = action.payload;
      });
  },
});

export default ExchangeDirectCostReducers.reducer;
